import { lastValueFrom } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

export interface RuntimeConfig {
  reverb: {
    key: string;
    wsHost: string;
    wsPort: number;
    wssPort: number;
    forceTLS: boolean;
  };
}

const CONFIG_URL = '/runtime-config.json';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private readonly http = new HttpClient(inject(HttpBackend));

  private _config: RuntimeConfig | null = null;

  get config(): RuntimeConfig | null {
    return this._config;
  }

  loadConfig(): Promise<void> {
    return lastValueFrom(
      this.http.get<RuntimeConfig>(CONFIG_URL, {
        headers: {
          ContentType: 'application/json',
        },
      }),
    ).then(
      (config) => {
        this._config = config;
      },
      (error: unknown) => {
        console.error('[RuntimeConfigService] Failed to load runtime config', error);
        this._config = null;
      },
    );
  }
}
